import _ from 'lodash';
import * as moment from 'moment';
import { AbstractControl, Validators } from '@angular/forms';
import { CampaignSponsorSchema } from './sponsor-group';

export const CampaignSchema = {
    'arrays': [{
        'array': 'sponsors',
        'schema': CampaignSponsorSchema,
        'value': [],
        'validators': []
    }],
    'fields': [{
        'field': 'id',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true,
        }
    }, {
        'field': 'sponsorGroupId',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true,
        }
    }, {
        'field': 'additionalInfoRequired',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                return _.isEmpty(data.additionalInfoDesc) ? false: true;
            }
        }
    }, {
        'field': 'additionalInfoSelectRequired',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                return _.isEmpty(data.additionalInfoSelect) ? false: true;
            }
        }
    },  {
        'field': 'coCampaignsRequired',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => _.isEmpty(data.coCampaigns) ? false: true
        }
    },  {
        'field': 'donationButtonLabelRequired',
        'value': '',
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => _.isEmpty(data.donationButtonLabel) ? false: true
        }
    }, 
    {
        'field': 'campaignPageImage',
        'value': '',
        'validators': [],
    },{
        'field': 'campaignPageImageRequired',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => {
                return _.isEmpty(data.campaignPageImage) ? false: true;
            }
        }
    },
    {
        'field': 'imageBelowFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    },{
        'field': 'hideCoverFee',
        'value': false,
        'validators': []
    }, {
        'field': 'donorFeeTextCheck',
        'value': false,
        'validators': [],
        'options': {
            'virtual': true,
            'setter': (data, value) => _.isEmpty(data.coverFeeText) ? false: true
        }
    }, {
        'field': 'imageFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'imageDataUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.imageUrl === '' ? '/images/blank_2x1.png': data.imageUrl
            }
        }
    }, {
        'field': 'imageUrl',
        'value': '/images/blank_2x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_2x1.png' ? '': control.value   
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_2x1.png': value
            }
        }
    }, {
        'field': 'thumbnailFile',
        'value': null,
        'validators': [],
        'options': {
            'virtual': true
        }
    }, {
        'field': 'thumbnailDataUrl',
        'value': '/images/blank_1x1.png',
        'validators': [],
        'options': {
            'virtual': true,
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return data.thumbnailUrl === '' ? '/images/blank_1x1.png': data.thumbnailUrl
            }
        }
    }, {
        'field': 'thumbnailUrl',
        'value': '/images/blank_1x1.png',
        'validators': [],
        'options': {
            'getter': (control) => {
                return control.value === '/images/blank_1x1.png' ? '': control.value
            },
            'setter': (data, value) => {
                return value === '' ? '/images/blank_1x1.png': value
            }
        }
    }, {
        'field': 'additionalInfoDesc',
        'value': '',
        'validators': [],
        'options': {
            'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required]
        }
    }, {
        'field': 'additionalInfoDetail',
        'value': '',
        'validators': []
    }, {
        'field': 'additionalInfoSelect',
        'value': [],
        'validators': [],
        'options': {
        'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required]
        }
    }, {
        'field': 'additionalInfoSelectDesc',
        'value': '',
        'validators': [],
        'options': {
            'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required]
        }
    }, {
        'field': 'coCampaigns',
        'value': [],
        'validators': [],
        'options': {
            'getter': (control) => _.isNumber(control.value) ? [control.value]: control.value,
            'setter': (data, value) => _.get(value, 'length', 0) > 0 ? value[0]: value,
            'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required]
        }
    }, {
        'field': 'coverFeeDefaultOff',
        'value': false,
        'validators': []
    }, {
        'field': 'coverFeeText',
        'value': '',
        'validators': [],
        'options': {
            'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required]
        }
    }, {
        'field': 'dedicationEnabled',
        'value': false,
        'validators': []
    }, {
        'field': 'desc',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'summary',
        'value': '',
        'validators': [],
        'options': {
            'getter': (control) => {
                const reg = new RegExp(String.fromCharCode(160), 'g');
                return control.value
                    .replaceAll(/<ol>(<li data-list="bullet">.*?<\/li>+)<\/ol>/g,"<ul>$1</ul>")
                    .replaceAll(reg, ' ');
            }
        }
    }, {
        'field': 'donationButtonLabel',
        'value': '',
        'validators': [],
        'options': {
            'validators': (data, value) => _.isEmpty(value) ? []: [Validators.required, Validators.pattern("[0-9a-zA-Z-_\ ]+")]
        }
    }, {
        'field': 'emailFooter',
        'value': '',
        'validators': []
    }, {
        'field': 'endDate',
        'value': () => null,
        'validators': [],
        'options': {
            'getter': (control, form) => {
                const endDateUnix = form.get("endDateUnix");
                const unix = moment(endDateUnix.value).unix() + 24 * 60 * 60 - 1;
                return endDateUnix.value ? moment.unix(unix).format("YYYY/MM/DD"): ''
            },
            'setter': (data, value) => {
                if(!value) {
                    return null;
                }
                const unix = moment.unix(value);
                const year = unix.year();
                return year < 2066 ? unix.format("MM/DD/YYYY"): null;
            }
        }
    }, {
        'field': 'endDateUnix',
        'value': () => null,
        'validators': [],
        'options': {
            'getter': (control) => control.value ? (moment(control.value).unix() + 24 * 60 * 60 - 1): 0,
            'setter': (data, value) => {
                if(!value) {
                    return null;
                }
                const unix = moment.unix(value);
                const year = unix.year();
                return year < 2066 ? unix.format("MM/DD/YYYY"): null;
            }
        }
    }, {
        'field': 'greeting',
        'value': '',
        'validators': []
    }, {
        'field': 'internalId',
        'value': '',
        'validators': []
    }, {
        'field': 'isDefault',
        'value': false,
        'validators': [],
        'options': {
            'getter': (control) => !control.value,
            'setter': (data, value) => !value
        }
    }, {
        'field': 'name',
        'value': '',
        'validators': [Validators.required, Validators.maxLength(128)]
    }, {
        'field': 'notifyTransactionEmails',
        'value': [],
        'validators': []
    }, {
        'field': 'phoneNumRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'phoneOptional',
        'value': false,
        'validators': []
    }, {
        'field': 'qualifiedTaxDeductible',
        'value': true,
        'validators': []
    }, {
        'field': 'redirectUrlRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'redirectUrl',
        'value': '',
        'validators': [],
        'options': {
            'validators': (data, value) => data.redirectUrlRequired ? [Validators.required, (control: AbstractControl) => {
                if(control.value === "") {
                    return null;
                }
                
                let url = true;
                try {
                  const urlString = control.value.substr(0,4) === "www." ? `https://${control.value}`: control.value;
                  new URL(urlString)
                } catch {
                  url = false;
                }
            
                return url ? null : { url: true };
            }]: []
        }
    }, {
        'field': 'startDate',
        'value': () => null,
        'validators': [],
        'options': {
            'getter': (control, form) => {
                const startDateUnix = form.get("startDateUnix");
                return startDateUnix.value ? moment(startDateUnix.value, "MM/DD/YYYY").format("YYYY/MM/DD"): ''
            },
            'setter': (data, value) => {
                if(!value) {
                    return null;
                }
                const unix = moment.unix(value);
                const year = unix.year();
                return year > 2015 ? unix.format("MM/DD/YYYY"): null;
            }
        }
    }, {
        'field': 'startDateUnix',
        'value': () => null,
        'validators': [],
        'options': {
            'getter': (control) => control.value ? moment(control.value, "MM/DD/YYYY").unix(): 0,
            'setter': (data, value) => {
                if(!value) {
                    return null;
                }
                const unix = moment.unix(value);
                const year = unix.year();
                return year > 2015 ? unix.format("MM/DD/YYYY"): null;
            }
        }
    }, {
        'field': 'streetAddressRequired',
        'value': false,
        'validators': []
    }, {
        'field': 'addressOptional',
        'value': false,
        'validators': []
    }, {
        'field': 'streetAddressReason',
        'value': '',
        'validators': [],
        'options': {
            'validators': (data, value) => data.streetAddressRequired ? [Validators.required]: []
        }
    }, {
        'field': 'timeZone',
        'value': () => (new Date()).getTimezoneOffset()*-60,
        'validators': [Validators.required],
        'options': {
            'setter': (data, value) => _.isFunction(value) ? value(): value
        }
    }, {
        'field': 'hideShareButtons',
        'value': false,
        'validators': []
    }]
};